module.exports = __webpack_public_path__ + "static/media/banner.7ac4ab95.jpg";